// LIST
export const FETCH_ASSIGNED_ROOMS = "app/Room/FETCH_ASSIGNED_ROOMS";
export const FETCH_ASSIGNED_ROOMS_SUCCESS =
  "app/Room/FETCH_ASSIGNED_ROOMS_SUCCESS";
export const FETCH_ASSIGNED_ROOMS_FAILURE =
  "app/Room/FETCH_ASSIGNED_ROOMS_FAILURE";
// GET VIEW DATA
export const GET_VIEW_DATA = "app/Room/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/Room/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/Room/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_ASSIGNED_ROOM = "app/Room/ADD_ASSIGNED_ROOM";
export const ADD_ASSIGNED_ROOM_SUCCESS = "app/Room/ADD_ASSIGNED_ROOM_SUCCESS";
export const ADD_ASSIGNED_ROOM_FAILURE = "app/Room/ADD_ASSIGNED_ROOM_FAILURE";
// EDIT
export const EDIT_ASSIGNED_ROOM = "app/Room/EDIT_ASSIGNED_ROOM";
export const EDIT_ASSIGNED_ROOM_SUCCESS = "app/Room/EDIT_ASSIGNED_ROOM_SUCCESS";
export const EDIT_ASSIGNED_ROOM_FAILURE = "app/Room/EDIT_ASSIGNED_ROOM_FAILURE";
// DELETE
export const DELETE_ASSIGNED_ROOMS = "app/Room/DELETE_ASSIGNED_ROOMS";
export const DELETE_ASSIGNED_ROOMS_SUCCESS =
  "app/Room/DELETE_ASSIGNED_ROOMS_SUCCESS";
export const DELETE_ASSIGNED_ROOMS_FAILURE =
  "app/Room/DELETE_ASSIGNED_ROOMS_FAILURE";

export const OPEN_ASSIGNED_ROOMS_MODAL = "app/Room/OPEN_ASSIGNED_ROOMS_MODAL";
export const CLOSE_ASSIGNED_ROOMS_MODAL = "app/Room/CLOSE_ASSIGNED_ROOMS_MODAL";
